import {
    LinkComponent as SourceLinkComponent,
} from 'SourceComponent/Link/Link.component';
import { Link as RouterLink } from 'react-router-dom';
import React from 'react';
import './Link.override.style';
import { stringify } from 'rebem-classname';

export class LinkComponent extends SourceLinkComponent {
    // shouldComponentUpdate(nextprops) {
    //     return false;
    // }
}

export default LinkComponent;
